import { BaseModel } from "@/models/base.model"
import { type IHoliday } from "@/interfaces/api/holiday.interface"
import { type Moment } from "moment"

export class Holiday extends BaseModel implements IHoliday {
  public static className = "Holiday" // Used for socket communication.
  public static verboseName = "feestdag"

  id: string
  name: string
  date: Moment

  constructor(holiday: IHoliday) {
    super(holiday)

    this.id = holiday.id
    this.name = holiday.name
    this.date = holiday.date
  }
}
